import axios from "axios";
import api from "../../../utils/api";
import { createAsyncThunk } from "@reduxjs/toolkit";
import { RootState } from "../../rootReducer";

const limit = 30;

export const fetchHojasDeCargo = createAsyncThunk(
  "hojaDeCargotList/fetch",
  async (data, { rejectWithValue, getState }) => {
    try {
      const state = getState() as RootState;

      const { searchText, statusFilter, createdAtFilter, sort, page } =
        state.supervisorDocumentsList;

      const user = state.userAuthentication.user;
      const locations = user?.locations ?? [];

      // Filtrar ubicaciones válidas antes de mapear
      const codes = locations
        .filter((loc): loc is { code: string } => loc.code !== undefined)
        .map((loc) => loc.code);

      const fromDate = new Date(createdAtFilter?.from!);
      const toDate = new Date(createdAtFilter?.to!);

      const parsedFromDate =
        fromDate.getFullYear() + "-" + (fromDate.getMonth() + 1) + "-" + fromDate.getDate();

      const parsedToDate =
        toDate.getFullYear() + "-" + (toDate.getMonth() + 1) + "-" + toDate.getDate();

      const skip = limit * (page - 1);

      // Validaciones para los datos
      const body = {
        where: {
          searchText: searchText || "", // Texto de búsqueda
          centroCostoId: codes.length > 0 ? codes : undefined, // Enviar sólo si hay datos
          createdAt:
            createdAtFilter?.from && createdAtFilter?.to
              ? {
                  ">=": `${parsedFromDate}`,
                  "<=": `${parsedToDate}`,
                }
              : undefined, // Enviar sólo si ambos valores existen
          statusDigitalSignature: statusFilter?.length
            ? { contains: statusFilter[0].name }
            : undefined, // Filtrar por estado de firma
          enable: true, // Siempre habilitado
        },
        sort: sort || "createdAt DESC",
        limit: limit || 30,
        skip: skip || 0,
      };

      // Realizar la solicitud POST
      const response = await axios.post(`${api.hojasDeCargoURL}hojacargo/searchAdvancedHC`, body);

      return response.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);